import React, {memo, useCallback, useMemo,} from "react";
import {useTranslation} from "react-i18next";
import {IGetPlanLongAPIParam, TSectorItem} from "../../../api/apiTypes";
import {queries} from "../../../api/queries";
import {isEnglish, isKorean, removeExistingParamsArrayValue} from "../../../common/fns";
import {LeftOutlined} from "@ant-design/icons";
import {Row, Table} from "antd";
import {useDataAll} from "../../../api/useDataAll";
import {useSearchParams} from "react-router-dom";
import {CustomTable} from "../../molecules/CustomTable";

type SortedSector = {
  code: string
}
type Props = {
  params: IGetPlanLongAPIParam;
}
export const SectorTable = memo(({params}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const [_, setSearchParams] = useSearchParams();
  const {
          listData, isLoading
        } = useDataAll<TSectorItem>(queries.location.sectors, {allowed: "1"});
  
  const sorted = useMemo(() => {
    if (!!listData?.sort) {
      let korean: any = {}, english: any = {}, other: any = {};
      listData.sort()
              .forEach((d) => {
                const code = d.code.replace(/[0-9]/g, '');
                if (isKorean(d.code)) {
                  korean[code] = {code}
                }
                else if (isEnglish(d.code)) {
                  english[code] = {code}
                }
                else if (!!d.code) {
                  other[code] = {code}
                }
              })
      const koreanList = Object.keys(korean)
                               .map((key) => ({code: key}))
      const englishList = Object.keys(english)
                                .map((key) => ({code: key}));
      const otherList = Object.keys(english)
                              .map((key) => ({code: key}));
      const sorted = [...koreanList, ...englishList, ...otherList]
      return sorted;
    }
    return [];
  }, [listData]);
  
  console.log("sorted", sorted, listData)
  
  const columns = [
    {
      title: t("sector"), render: (text: string, p: SortedSector, s: any) => {
        const selected = params.cluster_id_startswith_in_csv && params.cluster_id_startswith_in_csv.includes(p.code);
        return (<div className={"cell"}>
          {p.code}
          <LeftOutlined className={"arrow " + selected} />
        </div>)
      },
    },
  ];
  
  const handleChangeRow = useCallback((keys: any[], rows: SortedSector[]) => {
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "cluster_id_startswith_in_csv", keys), cluster_id_startswith_in_csv: keys
    }));
  }, [setSearchParams]);
  
  return (<CustomTable<SortedSector>
    columns={columns}
    dataSource={sorted}
    size={"small"}
    rootClassName={"sector-table"}
    pagination={false}
    rowSelection={{onChange: handleChangeRow, selectedRowKeys: params.cluster_id_startswith_in_csv}}
    loading={isLoading}
    scroll={{y: 'calc(100vh - (302px + 40px + 48px + 80px))'}}
    rowKey={"code"}
  />);
});
